import { Component, OnInit } from '@angular/core';
import { gsap, Power2, Power3, ScrollTrigger } from 'gsap/all';
import { Router } from '@angular/router';
import { ProjectsService } from '../services/projects.service';


// gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

name: string = "";
number: string = undefined;
email: string = "";
message: string = "";
  errorMessage: number = -1;

  ngOnInit(): void {

  //   var checkExist = setInterval(function() {
  //     if (document.querySelectorAll('.address').length) {

  //        this.address = document.querySelectorAll(".address");
  //        this.content = document.querySelectorAll("#contactusform");
  //        this.body = document.querySelectorAll(".contact_us");
  //        this.contact_us_head = document.querySelectorAll(".contact_us__heading");
  //        this.contact_us_img = document.querySelectorAll(".contact_us__img");
         

  //        const url = window.location.href;

  //        if(url.includes("/contact")) {

  //         // gsap.from(this.address, {
  //         //   x: 85,
  //         //   duration:1,
  //         //   opacity:0,
  //         //   ease: Power2.easeInOut
  //         // });
  
  //         gsap.from(this.content, {
  //           y: -100,
  //           duration:1.5,
  //           opacity:0,
  //           ease: Power2.easeInOut
  //         });

  //         gsap.from(this.contact_us_img, {
  //           y: 100,
  //           zIndex:0,
  //           duration:1.7,
  //           opacity:0,
  //           delay:0,
  //           ease: Power2.easeOut
  //         })

  //         gsap.from(this.contact_us_head, {
  //           y: 100,
  //           duration:1.7,
  //           zIndex:11,
  //           // opacity:0,
  //           ease: Power2.easeOut
  //         })

  //        } else {
  //         // gsap.from(this.address, {
  //         //   scrollTrigger: {
  //         //     trigger: this.body,
  //         //     scrub: true
  //         //   },
  //         //   x: 800
  //         // });
  
  //         gsap.from(this.content, {
  //           scrollTrigger: {
  //             trigger: this.body,
  //             scrub: true
  //           },
  //           y: -800,
  //           opacity: 0
  //         });

  //         gsap.from(this.contact_us_head, {
  //           scrollTrigger: {
  //             trigger: this.body,
  //             scrub: true
  //           },
  //           x: -300,
  //           // duration:1.7,
  //           zIndex:11,
  //           // opacity:0,
  //           // ease: Power2.easeOut
  //         })
  //        }

  //        clearInterval(checkExist);
  //     }
  //  }, 100);
  }

  constructor(private router: Router, private projectsService: ProjectsService) { 
    
  }


  // animate(){
  //   gsap.from(this.address, {
  //     scrollTrigger: {
  //       trigger: this.body,
  //       scrub: true
  //     },
  //     x: 800,
  //     duration: 2,
  //     ease: Power2.easeIn
  //   });
  // }

  sendMail() {

    if(this.number == undefined) {
      this.errorMessage = 1;
    } else {
      console.log(this.name, this.email, this.number, this.message);
      this.projectsService.sendMail(this.name, this.email, this.number, this.message).subscribe(res => {
        console.log(res);
        this.errorMessage = 0;

        this.name = "";
        this.email = "";
        this.number = undefined;
        this.message = "";
      });
    }
  }



}
